import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const LiWithFocusHighlight = styled.li`
	a:focus {
		color: ${token.gray900};
	}

	a:focus-visible {
		outline: ${token.focusRingWidth} solid ${token.focusRingColorPrimary} !important;
	}
`;
